import React, { useState } from "react";
import { Bounce, toast } from "react-toastify";
import Cookies from "universal-cookie";

const closeIcon = `${EASYCOMMERCE.assets}admin/img/icons/modal-close.png`;

const APIVarification = ({
    onClose,
    switchModalTab,
    setUserAfterVarification,
}) => {
    const [errMsg, setErrMsg] = useState("");

    const showToast = (type, message) => {
        toast[type](message, {
            position: "top-right",
            style: {
                margin: "30px 0 0 0",
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "26px",
                color: "#fff",
            },
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
        });
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();

        const email = e.target.email.value;
        const token = e.target.token.value;
        const source = EASYCOMMERCE.home_url;

        if (!token || !email) {
            showToast("error", "Please fill all the fields");
            return;
        }

        easycommerce_modal(true);
        setErrMsg("");

        fetch(`${EASYCOMMERCE.rest_base}/connectivity/token/verify`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
            body: JSON.stringify({ email: email, token: token, source: source }),
        })
            .then((res) => res.json())
            .then((data) => {
                easycommerce_modal(false);

                if (data.success && data.data.verified) {
                    const cookies = new Cookies(null, { path: "/" });

                    cookies.set("easy-user", JSON.stringify(data.data.user), {
                        path: "/",
                        maxAge: 86400 * 30,
                    });

                    setUserAfterVarification(data.data.user);

                    showToast("success", data.data.message);

                    onClose();
                } else {
                    setErrMsg(data.data.message);
                }
            });
    };

    return (
        <div className="fixed z-20 top-0 left-0 w-screen h-screen flex justify-center items-center bg-[#0000003B] backdrop-blur-sm">
            <div className="relative w-[548px] py-[50px] rounded-xl bg-white">
                <button className="absolute top-2 right-2" onClick={onClose}>
                    <img src={closeIcon} alt="close-icon" className="w-6 h-6" />
                </button>

                <div className="flex flex-col items-center gap-8">
                    <div className="flex flex-col items-center gap-[10px]">
                        <div className="flex flex-col items-center gap-3">
                            <h2 className="text-[#120350] text-2xl font-inter font-semibold">
                                Connect with API Key
                            </h2>
                            <p className="w-[70%] mx-auto text-center text-ec-placeholder font-inter font-normal text-base">
                                An API key is required to integrate your store into our system to ensure easy and seamless store management.
                            </p>
                        </div>

                        <div className="flex justify-between items-center gap-2">
                            <form
                                onSubmit={handleFormSubmit}
                                className="flex flex-col gap-6"
                                id="easycommerce-api-verify-form"
                            >
                                <div className="flex flex-col gap-3">
                                    <div>
                                        <label
                                            htmlFor="easycommerce-api-email-input"
                                            className="text-base leading-[26px] font-inter text-ec-body font-medium"
                                        >
                                            Your Email
                                        </label>
                                        <div className="pt-2 flex justify-between items-center gap-2">
                                            <input
                                                type="email"
                                                name="email"
                                                id="easycommerce-api-email-input"
                                                placeholder="Enter your Email"
                                                className="easycommerce-modal-input"
                                                style={{ width: "452px" }}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label
                                            htmlFor="easycommerce-api-key-input"
                                            className="text-base leading-[26px] font-inter text-ec-body font-medium"
                                        >
                                            Your API Key
                                        </label>
                                        <div className="pt-2 flex justify-between items-center gap-2">
                                            <textarea
                                                name="token"
                                                id="easycommerce-api-key-input"
                                                form="easycommerce-api-verify-form"
                                                placeholder="Enter API Key"
                                                className="easycommerce-modal-input"
                                                style={{ width: "452px" }}
                                                rows={4}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex flex-col items-center gap-3">
                                    <button
                                        type="submit"
                                        className="w-full rounded-md bg-ec-primary hover:bg-ec-secondary text-white 
                                        py-3 font-inter font-normal text-center text-base leading-[26px] transition-all 
                                        ease-in-out duration-300"
                                    >
                                        Verify
                                    </button>
                                    <div className="flex justify-center items-center gap-[2px]">
                                        <p className="font-inter text-ec-secondary text-base leading-[26px]">
                                            I don't have an
                                        </p>
                                        <button
                                            className="font-inter text-ec-primary text-base leading-[26px] underline"
                                            onClick={switchModalTab}
                                        >
                                            API Key
                                        </button>
                                    </div>
                                </div>

                                {errMsg && (
                                    <p
                                        className="w-full rounded-md bg-[#FF3A520D] text-[#FF3A52] 
                                        py-3 font-inter font-normal text-center text-sm"
                                    >
                                        {errMsg}
                                    </p>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default APIVarification;
